/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Link, Typography } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import { buildCourseraAssetsUrl, urlConstants } from 'bundles/common/utils/urlUtils';

import _t from 'i18n!nls/xddp';

const DEGREES_HUB_URL = urlConstants.hubPageRelativeUrls.degreesHub;
const imageUrl = buildCourseraAssetsUrl('growth_degrees/ddp/error-pages/IN_HERO_C.png');

const getUiStrings = () => ({
  bodyText: _t('Sorry, this degree is unavailable in your area. '),
  linkText: _t('See all degrees'),
  imageAltText: _t('Smiling learner with laptop and earbuds in the Coursera logo C'),
});

const styles: Record<string, Interpolation<Theme>> = {
  container: (theme: Theme) =>
    css({
      paddingTop: 'var(--cds-spacing-800)',
      paddingBottom: 'var(--cds-spacing-1400)',
      paddingRight: 'var(--cds-spacing-400)',
      paddingLeft: 'var(--cds-spacing-400)',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'var(--cds-color-grey-25)',
    }),
  heading: (theme: Theme) =>
    css({
      marginTop: 'var(--cds-spacing-800)',
      marginBottom: 'var(--cds-spacing-300)',
    }),
};

const DegreeNotAvailable = () => {
  const { bodyText, imageAltText, linkText } = getUiStrings();
  return (
    <div data-testid="degree-not-available" css={styles.container}>
      <Imgix src={imageUrl} maxWidth="300" alt={imageAltText} />
      <Typography variant="h1" css={styles.heading}>
        {bodyText}
        <Link href={DEGREES_HUB_URL}>{linkText}</Link>
      </Typography>
    </div>
  );
};

export default DegreeNotAvailable;
